import { fetchTotalPosition } from '@/api/business/unsettledSecurities'
import { useQuery } from '@tanstack/react-query'

export const TotalPositionKeys = {
    all: ['totalposition'] as const,
    lists: () => [...TotalPositionKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...TotalPositionKeys.lists(), page, perPage, filters] as const,
    details: () => [...TotalPositionKeys.all, 'detail'] as const,
    detail: (params: string) => [...TotalPositionKeys.details(), params] as const,
}

export const useTotalPositionQuery = () => {
    return useQuery({
        queryFn: fetchTotalPosition,
        queryKey: TotalPositionKeys.lists(),
    })
}
